import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';


type Emits = {
    (e: 'increment'): void
    (e: 'deincrement'): void
    (e: 'update:modelValue', time: Date): void
}
type Props = {
    availability: Date[][]
    modelValue: Date
}

export default /*#__PURE__*/_defineComponent({
  __name: 'time-scroller',
  props: {
    availability: null,
    modelValue: null
  },
  emits: ["increment", "deincrement", "update:modelValue"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'increment'): void
    (e: 'deincrement'): void
    (e: 'update:modelValue', time: Date): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    availability: Date[][]
    modelValue: Date
}





const scrollContainer = ref<HTMLElement | null>(null);

const handleWheel = (ev: WheelEvent) => {
    const cont = scrollContainer.value!;
    // console.log("At top:", cont.scrollHeight - cont.scrollTop === cont.clientHeight);
    if(cont.scrollTop === 0) emit('deincrement');
    // console.log("At bottom:", cont.scrollTop === 0);
}


const __returned__ = { emit, props, scrollContainer, handleWheel, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})